import React from 'react';
import { IconsPros } from './types';

/**
 * Publish Icon component
 *
 * @returns JSX.ELEMENT
 */
export const PublishIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M4.82,13.71c0,.21.1.28.28.14l2.57-2-2.6-1.59ZM15.59,2.09.22,6.3c-.25.07-.31.28,0,.41L3.31,8.23l1.86.9L15,3a.13.13,0,0,1,.16.19L7.94,9.9l-.42.4.49.31,4.07,2.58a.44.44,0,0,0,.66-.24L16,2.5C16.06,2.2,15.88,2,15.59,2.09Z" />
    </svg>
  );
};
